import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { searchEventsRoutePathByLocale } from '#/modules/search/routing/search.route-paths';
import type { searchEventsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { SearchEventsPageLoadable } from './SearchEventsPageLoadable';

export const handle = {
  urlByLocale: searchEventsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'EVENT',
  hideFooterDivider: true,
  searchFromPageType: 'SEARCH',
  showDesktopSearch: true,
  showSearchRefinements: true,
  isSearchPage: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchEventsRouteReference>,
) {
  await SearchEventsPageLoadable.load();
}

export default function SearchEventsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: events search page title */
        i18n('Social-Impact & Nonprofit Events | Online & Local Opportunities')
      }
    >
      <SearchEventsPageLoadable />
    </RouteModule>
  );
}
